import { FAQPageJsonLd } from "next-seo";

// // // //

export interface FaqItem {
    question: string;
    answer: string;
}

export function FrequentlyAskedQuestionSEO(props: { items: FaqItem[] }) {
    const { items } = props;

    return (
        <FAQPageJsonLd
            mainEntity={items.map((each) => {
                return {
                    questionName: each.question,
                    acceptedAnswerText: each.answer,
                };
            })}
        />
    );
}
